import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"
import { EmailTemplateDtoSchema, emailTemplateDtoListSchema, emailTemplateFromDto } from "@/models/email-template"
import type { EmailTemplate } from "@/models/email-template"

export function useGetEmailTemplates(options = {}) {
  return useQuery<EmailTemplate[]>({
    queryKey: ["email-templates"],
    queryFn: async () => {
      const response = await api.get("/api/email-templates", emailTemplateDtoListSchema)
      return response.Data.map(emailTemplateFromDto)
    },
    ...options,
  })
}

export function useGetEmailTemplate(id: string, options = {}) {
  return useQuery<EmailTemplate>({
    queryKey: ["email-templates", id],
    queryFn: async () => {
      const response = await api.get("/api/email-templates/$id", EmailTemplateDtoSchema, {
        pathReplace: { $id: id },
      })
      return emailTemplateFromDto(response)
    },
    enabled: !!id,
    ...options,
  })
}
